import MForm from './list.vue';

export default MForm;
